import './App.css';
import LoungeSearch from './Lounge/lounge';

function App() {
  return (
    <div>
      <LoungeSearch />
    </div>
  );
}

export default App;
